import { hostQueryKeys as e } from "./useHostsQueryKeys.mjs";
import { useSuspenseQuery as t } from "@maat/store-hooks";
import { hostsApi as n } from "@maat/api-main";
//#region src/hosts/useHostPublicProfileQuery.ts
var r = (r) => t({
	queryKey: e.profile(r),
	queryFn: () => n.getHostProfile(r)
});
//#endregion
export { r as useHostPublicProfileQuery };
